import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
  CartesianGrid,
  LabelList, // ✅ add this
} from "recharts";

import statisticApi from "../../api/statistic/statisticApi";
import { useSelector } from "react-redux";

const MonthlyAppointmentsLineChart = ({ orders = [] }) => {
  const today = moment().startOf("day");

  const chartData = useMemo(() => {
    const days = [];

    for (let i = 29; i >= 0; i--) {
      const day = today.clone().subtract(i, "days");
      days.push({
        name: day.format("MMM D"), // e.g. Apr 1
        date: day.format("YYYY-MM-DD"),
        orders: 0,
      });
    }

    orders.forEach((booking) => {
      const dateStr = moment(booking.createdAt).format("YYYY-MM-DD");
      const match = days.find((d) => d.date === dateStr);
      if (match) match.orders += 1;
    });

    return days;
  }, [orders]);

  const totalOrders = chartData.reduce((sum, d) => sum + d.orders, 0);

  const todayOrders =
    chartData.find((d) => d.date === moment().format("YYYY-MM-DD"))?.orders ||
    0;

  const peakOrders = Math.max(...chartData.map((d) => d.orders));

  const avgOrders = (totalOrders / 30).toFixed(1);

  return (
    <div className=" p-5 rounded-xl border border-navy min-h-[500px]">
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-xs uppercase tracking-wider text-navy">Orders</p>
          <h2 className="text-3xl font-semibold text-navy mt-1">
            {totalOrders}
          </h2>
          <p className="text-sm text-gray-400">
            Last 30 days • Avg {avgOrders}/day
          </p>
        </div>

        <div className="text-xs px-3 py-1 bg-green-50 text-green-600 rounded-full">
          Live
        </div>
      </div>
      <div className="mt-6 shadow-lg py-6">
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={chartData}>
            <XAxis
              dataKey="name"
              tick={{ fontSize: 10 }}
              interval={3}
              stroke="#132861"
            />
            <YAxis allowDecimals={false} stroke="#132861" />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="orders"
              stroke="#132861"
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-6 text-center">
        <div>
          <p className="text-xs text-gray-400">Today</p>
          <p className="font-semibold text-gray-900">{todayOrders}</p>
        </div>

        <div>
          <p className="text-xs text-gray-400">Peak</p>
          <p className="font-semibold text-gray-900">{peakOrders}</p>
        </div>

        <div>
          <p className="text-xs text-gray-400">Average</p>
          <p className="font-semibold text-gray-900">{avgOrders}</p>
        </div>
      </div>
    </div>
  );
};

export default MonthlyAppointmentsLineChart;
